import React from 'react'
import { useCallback, useState, useRef, useEffect, useMemo, RefObject } from 'react'
import { Services } from '@/services/services'
import { useNavigate, useParams } from 'react-router-dom'

import './Details.css'
import { Translates } from '@/services/repository/i18n'
import { CurrentSession } from '@/services/repository/session'
import { MainPageLayout } from '@/components/layout/MainLayout'
import { useLogin } from '@/context/login'
import { Machine } from '@/services/model/machine'
import { useModal } from '@/components/modal/Modal'
import { formatDateOnly } from '@/common/time'
import { MachinePath } from './Common'
import { BackButton } from '@/components/layout/NavBar'
import { MachinePopupDocBody } from '@/popups/docs/docs'
import { MachinePopupQRCodeBody } from '@/popups/qrcode/qrcode'
import { Roles } from '@/services/repository/users'
import { SuperAdminEditMachinesPopup } from '@/pages/dashboard/superadmin/machines/Machines'
import { MachineStatuses } from './statuses'


export const CommunalMachineDetails = ({ services, session }: { services: Services, session?: CurrentSession }) => {
  const navigate = useNavigate()
  const { openModal } = useModal()
  const mid = useParams().mid
  const [machine, setMachine] = useState<Machine>()
  const [translates, setTranslates] = useState<Translates>()

  const refreshData = () => {
    fetch(`/api/communal/machines/byid/${mid}`).then((response) => {
      return response.json()
    }).then((data) => {
      setMachine(data)
    })
  }

  useEffect(() => {
    if (session) {
      setTranslates(session.translates)
      return
    }
    services.i18n.get('main').then(setTranslates)
  }, [session])

  useEffect(() => {
    refreshData()
  }, [mid])

  if (translates === undefined) {
    return <div className='spinner'></div>
  }

  if (machine === undefined || translates === undefined) {
    return <div className='spinner'></div>
  }

  return <MainPageLayout pageName='communal-dashboard-details' services={services} translates={translates} session={session} path={[...MachinePath({ session, translates, machine }), {
    title: translates.for(`page.machinedetails.title`)
  }]}
    navbarLeft={<BackButton services={services} translates={translates} replaceUrl={`/communal/machine/${mid}`} />}>
    {/* <div className="container" style={{
      'backgroundImage': 'url("/public/img/machine/bgs/scissor-lift-background.PNG")',
      'backgroundSize':     '50%',
      'backgroundRepeat':   'no-repeat',
      'backgroundPosition': 'right center'
    }}> */}
    <div className="container">
      {machine.machineType?.manufacturer ? <div className='machine-logo-wrap'>
        <img src={`/public/img/machines/manufacture/${machine.machineType?.manufacturer}/logo.png`} />
      </div> : null}

      {MachineStatuses(translates, machine)}

      <div className="grid">
        {/* <div className="grid-item">
          <div className="label">{translates.for('forms.machine.fields.name.title')}</div>
          <div className="value">{machine.name}</div>
        </div> */}
        {/* <div className="grid-item">
            <div className="label">{translates.for('forms.machine.fields.companyID.title')}</div>
            <div className="value">{machine.companyId}</div>
          </div> */}
        <div className="grid-item">
          <div className="label">{translates.for('forms.machine.fields.manufacturer.title')}</div>
          <div className="value">{machine.machineType?.manufacturer || '-'}</div>
        </div>
        <div className="grid-item">
          <div className="label">{translates.for('forms.machine.fields.model.title')}</div>
          <div className="value">{machine.machineType?.model || '-'}</div>
        </div>
        <div className="grid-item">
          <div className="label">{translates.for('forms.machine.fields.internalNumber.title')}</div>
          <div className="value">{machine.internalNumber || '-'}</div>
        </div>
        { machine?.params?.deviceData?.ucid != undefined && machine?.params?.deviceData?.ucid !== '' ? <div className="grid-item">
          <div className="label">{translates.for('forms.machine.fields.ucid.title')}</div>
          <div className="value">{machine.params.deviceData.ucid || '-'}</div>
        </div> : null }
        { machine?.params?.deviceData?.soc != undefined ? <div className="grid-item">
          <div className="label">{translates.for('forms.machine.fields.soc.title')}</div>
          <div className="value">{machine.params.deviceData.soc || '-'}</div>
        </div> : null }
        { machine?.params?.deviceData?.engineHours != undefined ? <div className="grid-item">
          <div className="label">{translates.for('forms.machine.fields.engineHours.title')}</div>
          <div className="value">{machine.params.deviceData.engineHours || '-'}</div>
        </div> : null }
        { machine?.params?.deviceData?.ubat != undefined ? <div className="grid-item">
          <div className="label">{translates.for('forms.machine.fields.ubat.title')}</div>
          <div className="value">{machine.params.deviceData.ubat || '-'}</div>
        </div> : null }
        <div className="grid-item">
          <div className="label">{translates.for('forms.machine.fields.serialNumber.title')}</div>
          <div className="value">{machine.serialNumber || '-'}</div>
        </div>
        {/* <div className="grid-item">
            <div className="label">{translates.for('forms.machine.fields.machineTypeID.title')}</div>
            <div className="value">{machine.machineTypeId}</div>
          </div> */}
        {/* {session?.user.role === Roles.SuperAdmin ? <div className="grid-item">
          <div className="label">{translates.for('forms.machine.fields.udtReviewDate.title')}</div>
          <div className="value">{machine.udtReviewDate ? formatDateOnly(new Date(machine.udtReviewDate)) : '-'}</div>
        </div> : null} */}
        <div className="grid-item">
          <div className="label">{translates.for('forms.machine.fields.udtExpirationDate.title')}</div>
          <div className="value">{machine.udtExpirationDate ? formatDateOnly(new Date(machine.udtExpirationDate)) : '-'}</div>
        </div>
        {/* {session?.user.role === Roles.SuperAdmin ? <div className="grid-item">
          <div className="label">{translates.for('forms.machine.fields.inspectionDate.title')}</div>
          <div className="value">{machine.inspectionDate ? formatDateOnly(new Date(machine.inspectionDate)) : '-'}</div>
        </div> : null} */}
        <div className="grid-item">
          <div className="label">{translates.for('forms.machine.fields.inspectionExpirationDate.title')}</div>
          <div className="value">{machine.inspectionExpirationDate ? formatDateOnly(new Date(machine.inspectionExpirationDate)) : '-'}</div>
        </div>
        <div className="grid-item">
          <div className="label">{translates.for('forms.machine.fields.warrantyExpirationDate.title')}</div>
          <div className="value">{machine.warrantyExpirationDate ? formatDateOnly(new Date(machine.warrantyExpirationDate)) : '-'}</div>
        </div>
        <div className="grid-item">
          <div className="label">{translates.for('forms.machine.fields.manufactureDate.title')}</div>
          <div className="value">{machine.manufactureDate ? machine.manufactureDate : '-'}</div>
        </div>
        {session?.user.role === Roles.SuperAdmin ? <div className="grid-item">
          <div className="label">{translates.for('forms.machine.fields.imei.title')}</div>
          <div className="value">{machine.imei || '-'}</div>
        </div> : null}
        {/* {session?.user.role === Roles.SuperAdmin ? <div className="grid-item">
          <div className="label">{translates.for('forms.machine.fields.id.title')}</div>
          <div className="value">{machine.id || '-'}</div>
        </div> : null} */}
        
      </div>

      <div className='btns'>
        {/* <a className='main-btn' onClick={() => { navigate(`/communal/machine/${mid}/teltonika`) }}>
          {translates.for('menus.communal.machine.monitoring')}
        </a> */}
        {/* <a className='main-btn' onClick={() => { navigate(`/communal/machine/${mid}/details`) }}>
          {translates.for('menus.communal.machine.details')}
        </a> */}
        {machine.machineTypeId ? <a className='main-btn' onClick={() => { openModal((props) => MachinePopupDocBody({ ...props, machineTypeId: machine.machineTypeId, session, services, translates })) }}>
          {translates.for('menus.communal.machine.documentation')}
        </a> : null}
        {session?.user.role === Roles.SuperAdmin ? <a className='main-btn' onClick={() => openModal((props) => MachinePopupQRCodeBody({ ...props, machineId: mid, services, session, translates }))}>
          {translates.for('menus.communal.machine.open_qrcode')}
        </a> : null}
        {session?.user.role === Roles.SuperAdmin ? <a className='main-btn' onClick={() => { navigate(`/communal/machine/${mid}/failures`) }}>
          {translates.for('menus.communal.machine.failure_list')}
        </a> : null}
        <a className='main-red-btn' onClick={() => { navigate(`/communal/machine/${mid}/failures/add`) }}>
          {translates.for('menus.communal.machine.failure')}
        </a>

        {session && session?.user.role == Roles.SuperAdmin ? <a className='main-green-btn' onClick={() => openModal((props) => SuperAdminEditMachinesPopup({
          ...props, machineId: mid, onClose: () => {
            refreshData()
            props.onClose()
          }, services, session
        }))}>
          {translates.for('menus.communal.machine.edit')}
        </a> : null}
      </div>
    </div>
  </MainPageLayout>
}
